var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewFavouriteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.02539,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9189 18.8454C21.6599 19.0964 21.5409 19.4594 21.5999 19.8154L22.4889 24.7354C22.5639 25.1524 22.3879 25.5744 22.0389 25.8154C21.6969 26.0654 21.2419 26.0954 20.8689 25.8954L16.4399 23.5854C16.2859 23.5034 16.1149 23.4594 15.9399 23.4544H15.6689C15.5749 23.4684 15.4829 23.4984 15.3989 23.5444L10.9689 25.8654C10.7499 25.9754 10.5019 26.0144 10.2589 25.9754C9.66688 25.8634 9.27188 25.2994 9.36888 24.7044L10.2589 19.7844C10.3179 19.4254 10.1989 19.0604 9.93988 18.8054L6.32888 15.3054C6.02688 15.0124 5.92188 14.5724 6.05988 14.1754C6.19388 13.7794 6.53588 13.4904 6.94888 13.4254L11.9189 12.7044C12.2969 12.6654 12.6289 12.4354 12.7989 12.0954L14.9889 7.60539C15.0409 7.50539 15.1079 7.41339 15.1889 7.33539L15.2789 7.26539C15.3259 7.21339 15.3799 7.17039 15.4399 7.13539L15.5489 7.09539L15.7189 7.02539H16.1399C16.5159 7.06439 16.8469 7.28939 17.0199 7.62539L19.2389 12.0954C19.3989 12.4224 19.7099 12.6494 20.0689 12.7044L25.0389 13.4254C25.4589 13.4854 25.8099 13.7754 25.9489 14.1754C26.0799 14.5764 25.9669 15.0164 25.6589 15.3054L21.9189 18.8454Z",
    fill: "#EAB33B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.02539,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFavouriteIcon);
export default __webpack_public_path__ + "static/media/new-favourite-icon.a9bb0676e0988e02eecba1c6b3302e3f.svg";
export { ForwardRef as ReactComponent };